import { combineReducers } from 'redux';

import usersReducer from './users/ducks';

const rootReducer = combineReducers({
  usersReducer,
});

export default rootReducer;
